import {
  LIST_PRODUCTS,
  LOADING_LIST_PRODUCTS,
} from '@/src/application/constants/homePage';

const initialState = {
  listProduct: [],
  loadingListProduct: true,
};

export default function reducer(
  state = initialState,
  action = {
    type: '',
    listProduct: [],
  }
) {
  const {
    type,
    listProduct,
  } = action;
  switch (type) {
    case LIST_PRODUCTS:
      return {
        ...state,
        listProduct: listProduct,
        loadingListProduct: false,
      };
    case LOADING_LIST_PRODUCTS:
      return {
        ...state,
        loadingListProduct: true,
      };

    default:
      return state;
  }
}
